module.exports = __webpack_public_path__ + "static/media/Broadwayworld Indonesia logo-1.401ad302.png";